// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lc-am-divider.is-vertical[data-v-1b1055d4]{display:inline-block}.lc-am-divider.is-horizontal[data-v-1b1055d4]{padding:24px 0}.lc-am-divider.is-horizontal .yxtf-divider--horizontal[data-v-1b1055d4]{margin:0}", ""]);
// Exports
module.exports = exports;
